<ng-container *ngIf="!isAuthRoute(); else authOnly">
  <!-- Dynamic Background Image -->
  <div class="fixed inset-0 -z-10">
    <!-- Background image loaded from platform settings -->
    <!-- Removed bg-fixed for better Firefox performance -->
    <div
      class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      [style.background-image]="'url(' + backgroundImageUrl() + ')'"
      [style.background-attachment]="'scroll'"
    ></div>
    <!-- Subtle overlay to enhance glass effect visibility -->
    <div
      class="absolute inset-0 bg-gradient-to-br from-white/5 via-transparent to-black/10 dark:from-slate-900/30 dark:via-transparent dark:to-black/20"
    ></div>
  </div>

  <div
    class="h-screen flex overflow-hidden text-slate-900 dark:text-slate-100 relative z-0 bg-transparent"
  >
    <!-- Glass Effect Sidebar -->
    <aside
      class="hidden md:flex flex-col transition-all duration-300 ease-out h-screen overflow-y-auto z-20 glass-sidebar"
      [style.width.px]="sidebarWidth()"
    >
      <!-- Logo Section -->
      <div
        class="h-16 flex items-center px-4 border-b border-slate-200/50 dark:border-slate-700/50"
        [ngClass]="{ 'justify-center': isSidebarCollapsed() }"
      >
        <div class="flex items-center gap-3">
          <div
            class="h-10 w-10 rounded-xl grid place-items-center text-white shadow-lg"
            style="
              background-image: radial-gradient(
                120% 120% at 80% 0%,
                #8b5cf6 0%,
                #6366f1 40%,
                #3b82f6 100%
              );
            "
          >
            <span class="text-lg font-bold">M</span>
          </div>
          <span
            class="text-xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent"
            *ngIf="!isSidebarCollapsed()"
            >MIS</span
          >
        </div>
      </div>

      <!-- Navigation Sections -->
      <nav class="flex-1 px-3 py-4 space-y-6 overflow-y-auto">
        <!-- Dynamic Menus from UI Config -->
        @if (dynamicMenus().length > 0) {
          <div>
            <div class="space-y-1">
              <app-dynamic-menu
                [menus]="dynamicMenus()"
                [isCollapsed]="isSidebarCollapsed()"
              ></app-dynamic-menu>
            </div>
          </div>
        }

        <!-- Static Menus (Fallback when no dynamic config) -->
        @if (dynamicMenus().length === 0) {
          <!-- Collaboration Section -->
          <div>
            <h3
              class="px-3 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2"
              *ngIf="!isSidebarCollapsed()"
            >
              Collaboration
            </h3>
            <div class="space-y-1">
              <a
                routerLink="/messenger"
                routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors group relative"
                [ngClass]="
                  isSidebarCollapsed()
                    ? 'justify-center px-0 py-2.5'
                    : 'gap-3 px-3 py-2.5'
                "
                [attr.title]="isSidebarCollapsed() ? 'Messenger' : null"
              >
                <svg
                  class="h-5 w-5"
                  [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
                  />
                </svg>
                <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                  >Messenger</span
                >
                <span
                  *ngIf="!isSidebarCollapsed()"
                  class="ml-auto bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
                  >1</span
                >
              </a>
              <a
                routerLink="/feed"
                routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                [ngClass]="
                  isSidebarCollapsed()
                    ? 'justify-center px-0 py-2.5'
                    : 'gap-3 px-3 py-2.5'
                "
                [attr.title]="isSidebarCollapsed() ? 'Feed' : null"
              >
                <svg
                  class="h-5 w-5"
                  [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5M6 7.5h3v4.5H6v-4.5z"
                  />
                </svg>
                <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                  >Feed</span
                >
              </a>
              <a
                routerLink="/calendar"
                routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                [ngClass]="
                  isSidebarCollapsed()
                    ? 'justify-center px-0 py-2.5'
                    : 'gap-3 px-3 py-2.5'
                "
                [attr.title]="isSidebarCollapsed() ? 'Calendar' : null"
              >
                <svg
                  class="h-5 w-5"
                  [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                  />
                </svg>
                <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                  >Calendar</span
                >
              </a>
              <a
                routerLink="/drive"
                routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                [ngClass]="
                  isSidebarCollapsed()
                    ? 'justify-center px-0 py-2.5'
                    : 'gap-3 px-3 py-2.5'
                "
                [attr.title]="isSidebarCollapsed() ? 'Drive' : null"
              >
                <svg
                  class="h-5 w-5"
                  [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                  />
                </svg>
                <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                  >Drive</span
                >
              </a>
            </div>
          </div>

          <!-- Platform Owner Menu -->
          @if (auth.isPlatformOwner()) {
            <div>
              <h3
                class="px-3 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2"
                *ngIf="!isSidebarCollapsed()"
              >
                Platform
              </h3>
              <div class="space-y-1">
                <a
                  routerLink="/platform"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="
                    isSidebarCollapsed() ? 'Platform Dashboard' : null
                  "
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M3.75 12l8.25-8.25L20.25 12v7.5a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V12z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Platform Dashboard</span
                  >
                </a>
                <a
                  routerLink="/platform/tenants"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Tenants' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Tenants</span
                  >
                </a>
                <a
                  routerLink="/platform/analytics"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Analytics' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Analytics</span
                  >
                </a>
                <a
                  routerLink="/platform/monitoring"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Monitoring' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M3 8.25h18M3 12h18M3 15.75h18"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Monitoring</span
                  >
                </a>
                <a
                  routerLink="/platform/settings"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Settings' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Settings</span
                  >
                </a>
                <a
                  routerLink="/platform/configuration"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Configuration' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75A2.25 2.25 0 001.5 12.75v6.75a2.25 2.25 0 002.25 2.25z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Configuration</span
                  >
                </a>
                <a
                  routerLink="/platform/billing"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Billing' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75m15 0h.008v.008H15v-.008z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Billing</span
                  >
                </a>
                <a
                  routerLink="/platform/branding"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Branding' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 007.288-2.245 3.375 3.375 0 003.75-3.75v-.75a3 3 0 00-3-3h-1.5v-1.5a3 3 0 00-3-3H3a3 3 0 00-3 3v1.5h1.5a3 3 0 003 3h.75v.75a3 3 0 003 3z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Branding</span
                  >
                </a>
                <a
                  routerLink="/platform/backgrounds"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Backgrounds' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Backgrounds</span
                  >
                </a>
                <a
                  routerLink="/platform/audit-logs"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Audit Logs' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Audit Logs</span
                  >
                </a>
                <a
                  routerLink="/platform/backups"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Backups' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Backups</span
                  >
                </a>
                <a
                  routerLink="/platform/ui-config"
                  routerLinkActive="bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="
                    isSidebarCollapsed() ? 'UI Configuration' : null
                  "
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >UI Configuration</span
                  >
                </a>
              </div>
            </div>
          }

          <!-- Tasks and Projects Section -->
          <div>
            <h3
              class="px-3 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2"
              *ngIf="!isSidebarCollapsed()"
            >
              Tasks & Projects
            </h3>
            <div class="space-y-1">
              @if (!auth.isPlatformOwner()) {
                <a
                  routerLink="/"
                  routerLinkActive="bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"
                  class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                  [ngClass]="
                    isSidebarCollapsed()
                      ? 'justify-center px-0 py-2.5'
                      : 'gap-3 px-3 py-2.5'
                  "
                  [attr.title]="isSidebarCollapsed() ? 'Dashboard' : null"
                >
                  <svg
                    class="h-5 w-5"
                    [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M3.75 12l8.25-8.25L20.25 12v7.5a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V12z"
                    />
                  </svg>
                  <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                    >Dashboard</span
                  >
                </a>
              }
              <a
                routerLink="/tasks"
                routerLinkActive="bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"
                class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                [ngClass]="
                  isSidebarCollapsed()
                    ? 'justify-center px-0 py-2.5'
                    : 'gap-3 px-3 py-2.5'
                "
                [attr.title]="isSidebarCollapsed() ? 'Tasks' : null"
              >
                <svg
                  class="h-5 w-5"
                  [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M9 12l2 2 4-4m-9 8h10.5A1.5 1.5 0 0018 16.5V6A1.5 1.5 0 0016.5 4.5H7.5A1.5 1.5 0 006 6v10.5A1.5 1.5 0 007.5 18z"
                  />
                </svg>
                <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                  >Tasks</span
                >
              </a>
              <a
                routerLink="/projects"
                routerLinkActive="bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"
                class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                [ngClass]="
                  isSidebarCollapsed()
                    ? 'justify-center px-0 py-2.5'
                    : 'gap-3 px-3 py-2.5'
                "
                [attr.title]="isSidebarCollapsed() ? 'Projects' : null"
              >
                <svg
                  class="h-5 w-5"
                  [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
                  />
                </svg>
                <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                  >Projects</span
                >
              </a>
              <a
                routerLink="/users"
                routerLinkActive="bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300"
                class="flex items-center rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
                [ngClass]="
                  isSidebarCollapsed()
                    ? 'justify-center px-0 py-2.5'
                    : 'gap-3 px-3 py-2.5'
                "
                [attr.title]="isSidebarCollapsed() ? 'Users' : null"
              >
                <svg
                  class="h-5 w-5"
                  [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                  />
                </svg>
                <span *ngIf="!isSidebarCollapsed()" class="font-medium"
                  >Users</span
                >
              </a>
            </div>
          </div>

          <!-- More Sections -->
          <div *ngIf="!isSidebarCollapsed()">
            <h3
              class="px-3 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2"
            >
              More
            </h3>
            <div class="space-y-1">
              <a
                routerLink="/reports"
                routerLinkActive="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300"
                class="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
              >
                <svg
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z"
                  />
                </svg>
                <span class="font-medium">Reports</span>
              </a>
              <a
                routerLink="/admin"
                routerLinkActive="bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300"
                class="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-100/80 dark:hover:bg-slate-800/50 transition-colors"
              >
                <svg
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span class="font-medium">Settings</span>
              </a>
            </div>
          </div>
        }
      </nav>

      <!-- Bottom Section -->
      <div
        class="px-3 py-4 border-t border-slate-200/50 dark:border-slate-700/50"
        *ngIf="isAuthenticated()"
      >
        <button
          (click)="logout()"
          class="w-full flex items-center rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 text-red-600 dark:text-red-400 transition-colors"
          [ngClass]="
            isSidebarCollapsed()
              ? 'justify-center px-0 py-2.5'
              : 'gap-3 px-3 py-2.5'
          "
          [attr.title]="isSidebarCollapsed() ? 'Logout' : null"
        >
          <svg
            class="h-5 w-5"
            [ngClass]="{ 'mx-auto': isSidebarCollapsed() }"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
            />
          </svg>
          <span *ngIf="!isSidebarCollapsed()" class="font-medium">Logout</span>
        </button>
      </div>
    </aside>

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
      <!-- Top Header Bar with Glass Effect -->
      <header
        class="h-16 flex-shrink-0 flex items-center justify-between px-4 md:px-6 z-10 relative glass-header"
      >
        <!-- Left: Logo and Navigation Tabs -->
        <div class="flex items-center gap-4 flex-1 min-w-0">
          <button
            class="md:hidden p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800"
            (click)="toggleSidebar()"
          >
            <svg
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>

          <button
            class="hidden md:inline-flex items-center justify-center h-9 w-9 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            (click)="toggleCollapse()"
            [attr.title]="
              isSidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'
            "
          >
            <svg
              *ngIf="!isSidebarCollapsed()"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.75 19.5L8.25 12l7.5-7.5"
              />
            </svg>
            <svg
              *ngIf="isSidebarCollapsed()"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8.25 19.5L15.75 12 8.25 4.5"
              />
            </svg>
          </button>
        </div>

        <!-- Right: Search, Cache Clear, Notifications, User Menu -->
        <div class="flex items-center gap-2">
          <!-- Search -->
          <div class="relative">
            <button
              (click)="toggleSearch()"
              class="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            >
              <svg
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
            </button>
            <!-- Search Dropdown -->
            <div
              *ngIf="showSearch()"
              class="absolute right-0 top-full mt-2 w-96 rounded-xl shadow-2xl z-50 glass-dropdown"
              (click)="$event.stopPropagation()"
            >
              <div class="p-4">
                <input
                  type="text"
                  [value]="searchQuery()"
                  (input)="searchQuery.set($any($event.target).value)"
                  (keyup.enter)="performSearch()"
                  placeholder="Search tasks, projects, users..."
                  class="w-full px-4 py-3 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              </div>
            </div>
          </div>

          <!-- Cache Clear Button -->
          <button
            (click)="clearCacheAndReload()"
            class="p-2 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors group"
            title="Clear cache and reload (hard refresh)"
          >
            <svg
              class="h-5 w-5 text-red-600 dark:text-red-400 group-hover:text-red-700 dark:group-hover:text-red-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </button>

          <!-- Notifications -->
          <div class="relative">
            <button
              (click)="toggleNotifications()"
              class="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors relative"
            >
              <svg
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
                />
              </svg>
              <span
                *ngIf="notificationCount() > 0"
                class="absolute -top-1 -right-1 min-w-[20px] h-5 px-1.5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center animate-pulse"
              >
                {{ notificationCount() > 99 ? "99+" : notificationCount() }}
              </span>
            </button>
            <!-- Notifications Dropdown -->
            <div
              *ngIf="showNotifications()"
              class="absolute right-0 top-full mt-2 w-96 rounded-xl shadow-2xl z-[9998] max-h-[600px] overflow-hidden flex flex-col glass-dropdown border border-slate-200 dark:border-slate-700"
              (click)="$event.stopPropagation()"
            >
              <!-- Header -->
              <div
                class="p-4 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between bg-white dark:bg-slate-800"
              >
                <div class="flex items-center gap-3">
                  <h3
                    class="font-semibold text-lg text-slate-900 dark:text-white"
                  >
                    Notifications
                  </h3>
                  <span
                    *ngIf="notificationCount() > 0"
                    class="px-2 py-0.5 bg-red-500 text-white text-xs font-bold rounded-full"
                  >
                    {{ notificationCount() }} new
                  </span>
                </div>
                <div class="flex items-center gap-2">
                  <!-- Sound Toggle -->
                  <button
                    (click)="notificationSound.toggle()"
                    [title]="
                      notificationSound.enabled()
                        ? 'Disable notification sound'
                        : 'Enable notification sound'
                    "
                    class="p-1.5 rounded hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
                  >
                    <svg
                      *ngIf="notificationSound.enabled()"
                      class="w-4 h-4 text-blue-600 dark:text-blue-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-1.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <svg
                      *ngIf="!notificationSound.enabled()"
                      class="w-4 h-4 text-slate-400 dark:text-slate-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  <button
                    *ngIf="notificationCount() > 0"
                    (click)="markAllAsRead(); $event.stopPropagation()"
                    class="text-xs text-blue-600 dark:text-blue-400 hover:underline font-medium"
                  >
                    Mark all read
                  </button>
                  <a
                    routerLink="/notifications"
                    (click)="
                      showNotifications.set(false); $event.stopPropagation()
                    "
                    class="text-xs text-blue-600 dark:text-blue-400 hover:underline font-medium"
                  >
                    View all
                  </a>
                </div>
              </div>

              <!-- Loading State -->
              <div
                *ngIf="loadingNotifications()"
                class="flex items-center justify-center py-12"
              >
                <div
                  class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
                ></div>
              </div>

              <!-- Notifications List -->
              <div
                *ngIf="!loadingNotifications()"
                class="overflow-y-auto flex-1 max-h-[500px] min-h-[200px]"
                (click)="$event.stopPropagation()"
              >
                <div
                  *ngIf="notifications().length > 0"
                  class="divide-y divide-slate-200 dark:divide-slate-700"
                >
                  <div
                    *ngFor="let notification of notifications()"
                    (click)="
                      navigateToNotification(notification);
                      $event.stopPropagation()
                    "
                    [class]="
                      'p-4 cursor-pointer transition-colors hover:bg-slate-50 dark:hover:bg-slate-700/50 ' +
                      (notification.read
                        ? 'bg-white dark:bg-slate-800'
                        : 'bg-blue-50 dark:bg-blue-900/20')
                    "
                  >
                    <div class="flex items-start gap-3">
                      <!-- Notification Icon & Unread Indicator -->
                      <div class="relative flex-shrink-0 mt-0.5">
                        <div
                          [ngClass]="{
                            'bg-blue-100 dark:bg-blue-900/30':
                              notification.type === 'task_assigned' ||
                              notification.type === 'task_created',
                            'bg-green-100 dark:bg-green-900/30':
                              notification.type === 'success',
                            'bg-yellow-100 dark:bg-yellow-900/30':
                              notification.type === 'task_due_soon' ||
                              notification.type === 'warning',
                            'bg-red-100 dark:bg-red-900/30':
                              notification.type === 'task_overdue' ||
                              notification.type === 'error',
                            'bg-purple-100 dark:bg-purple-900/30':
                              notification.type === 'comment_added' ||
                              notification.type === 'mention',
                            'bg-gray-100 dark:bg-gray-700': !notification.type,
                          }"
                          class="w-10 h-10 rounded-lg flex items-center justify-center"
                        >
                          <svg
                            class="w-5 h-5"
                            [ngClass]="{
                              'text-blue-600 dark:text-blue-400':
                                notification.type === 'task_assigned' ||
                                notification.type === 'task_created',
                              'text-green-600 dark:text-green-400':
                                notification.type === 'success',
                              'text-yellow-600 dark:text-yellow-400':
                                notification.type === 'task_due_soon' ||
                                notification.type === 'warning',
                              'text-red-600 dark:text-red-400':
                                notification.type === 'task_overdue' ||
                                notification.type === 'error',
                              'text-purple-600 dark:text-purple-400':
                                notification.type === 'comment_added' ||
                                notification.type === 'mention',
                              'text-gray-600 dark:text-gray-400':
                                !notification.type,
                            }"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              *ngIf="
                                notification.type === 'task_assigned' ||
                                notification.type === 'task_created'
                              "
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            ></path>
                            <path
                              *ngIf="
                                notification.type === 'comment_added' ||
                                notification.type === 'mention'
                              "
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                            ></path>
                            <path
                              *ngIf="
                                !notification.type ||
                                (notification.type !== 'task_assigned' &&
                                  notification.type !== 'task_created' &&
                                  notification.type !== 'comment_added' &&
                                  notification.type !== 'mention')
                              "
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                            ></path>
                          </svg>
                        </div>
                        <!-- Unread Indicator -->
                        <div
                          *ngIf="!notification.read"
                          class="absolute -top-1 -right-1 w-3 h-3 bg-blue-600 rounded-full border-2 border-white dark:border-slate-800"
                        ></div>
                      </div>

                      <!-- Notification Content -->
                      <div class="flex-1 min-w-0">
                        <div class="flex items-start justify-between gap-2">
                          <h4
                            class="text-sm font-semibold text-slate-900 dark:text-white line-clamp-1"
                          >
                            {{ notification.title }}
                          </h4>
                          <button
                            (click)="
                              markNotificationAsRead(notification, $event);
                              $event.stopPropagation()
                            "
                            *ngIf="!notification.read"
                            class="flex-shrink-0 p-1 rounded hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors"
                            title="Mark as read"
                          >
                            <svg
                              class="w-4 h-4 text-slate-400"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M5 13l4 4L19 7"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        <p
                          class="mt-1 text-sm text-slate-600 dark:text-slate-300 line-clamp-2"
                        >
                          {{ notification.message }}
                        </p>
                        <div class="mt-2 flex items-center gap-3 flex-wrap">
                          <span
                            class="text-xs text-slate-500 dark:text-slate-400"
                          >
                            {{ formatDate(notification.createdAt) }}
                          </span>
                          <span
                            *ngIf="notification.priority"
                            [ngClass]="{
                              'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200':
                                notification.priority === 'URGENT',
                              'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200':
                                notification.priority === 'HIGH',
                              'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200':
                                notification.priority === 'NORMAL',
                              'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300':
                                notification.priority === 'LOW',
                            }"
                            class="px-2 py-0.5 rounded text-xs font-medium"
                          >
                            {{ notification.priority }}
                          </span>
                          <span
                            *ngIf="notification.actionRequired"
                            class="px-2 py-0.5 bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200 rounded text-xs font-medium"
                          >
                            Action Required
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Empty State -->
                <div
                  *ngIf="
                    !loadingNotifications() && notifications().length === 0
                  "
                  class="flex flex-col items-center justify-center py-12 px-4"
                >
                  <svg
                    class="w-16 h-16 text-slate-400 mb-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    ></path>
                  </svg>
                  <p
                    class="text-sm font-medium text-slate-600 dark:text-slate-400"
                  >
                    No notifications
                  </p>
                  <p class="text-xs text-slate-500 dark:text-slate-500 mt-1">
                    You're all caught up!
                  </p>
                </div>
              </div>

              <!-- Footer -->
              <div
                *ngIf="notifications().length > 0"
                class="p-3 border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50"
              >
                <a
                  routerLink="/notifications"
                  (click)="
                    showNotifications.set(false); $event.stopPropagation()
                  "
                  class="block text-center text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline"
                >
                  View all notifications
                </a>
              </div>
            </div>
          </div>

          <!-- Dark Mode Toggle (UPDATED ICONS) -->
          <button
            (click)="toggleTheme()"
            class="p-2 rounded-xl hover:bg-slate-100/70 dark:hover:bg-slate-900/40 transition-colors"
            [title]="
              darkMode() ? 'Switch to light mode' : 'Switch to dark mode'
            "
          >
            <!-- Show SUN when currently in dark mode (click -> light) -->
            <svg
              *ngIf="darkMode()"
              class="h-5 w-5 text-amber-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 18a6 6 0 100-12 6 6 0 000 12z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
              />
            </svg>

            <!-- Show MOON+STARS when currently in light mode (click -> dark) -->
            <svg
              *ngIf="!darkMode()"
              class="h-5 w-5 text-slate-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 14.5A8.5 8.5 0 1110 3.5a7 7 0 0011 11z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17.5 3.5l.3.9.9.3-.9.3-.3.9-.3-.9-.9-.3.9-.3.3-.9zM19.8 7.2l.2.6.6.2-.6.2-.2.6-.2-.6-.6-.2.6-.2.2-.6z"
              />
            </svg>
          </button>
          <!-- Local Date + Time -->
          <div
            class="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-xl border border-slate-200/60 bg-white/55 backdrop-blur-xl dark:border-slate-800/70 dark:bg-slate-950/25"
            title="Local date and time"
          >
            <svg
              class="h-4 w-4 text-slate-500 dark:text-slate-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 7V3m8 4V3M4 11h16M6 21h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>

            <div
              class="text-sm font-semibold text-slate-600 dark:text-slate-400 whitespace-nowrap tabular-nums font-mono min-w-[22ch] text-right"
            >
              {{ currentTime() }}
            </div>
          </div>

          <!-- User Menu -->
          <div class="relative">
            <!-- <button (click)="toggleUserMenu()" 
                    class="flex items-center gap-2 p-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
              <div class="h-8 w-8 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-white font-semibold text-sm">
                {{ currentUser()?.email?.charAt(0).toUpperCase() || 'U' }}
              </div>
            </button> -->
            <!-- User Menu Dropdown -->
            <div
              *ngIf="showUserMenu()"
              class="absolute right-0 top-full mt-2 w-64 rounded-xl shadow-2xl z-50 glass-dropdown"
              (click)="$event.stopPropagation()"
            >
              <div class="p-4 border-b border-slate-200 dark:border-slate-700">
                <p class="font-semibold">
                  {{ currentUser()?.email || "User" }}
                </p>
                <p class="text-sm text-slate-500 dark:text-slate-400">
                  {{ currentUser()?.username || "No username" }}
                </p>
              </div>
              <div class="p-2" (click)="$event.stopPropagation()">
                <a
                  routerLink="/profile"
                  (click)="closeMenus()"
                  class="block px-3 py-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 text-sm"
                  >Profile</a
                >
                <a
                  routerLink="/settings"
                  (click)="closeMenus()"
                  class="block px-3 py-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 text-sm"
                  >Settings</a
                >
                <button
                  (click)="logout(); $event.stopPropagation(); closeMenus()"
                  class="w-full text-left px-3 py-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 text-red-600 dark:text-red-400 text-sm"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- Main Content -->
      <main class="flex-1 overflow-y-auto p-4 md:p-6 bg-transparent">
        <router-outlet></router-outlet>
      </main>
    </div>

    <!-- Password Change Modal - Shows before dashboard for first-time users -->
    <app-password-change-modal
      *ngIf="auth.requiresPasswordChange() && auth.isAuthenticated()"
      (passwordChanged)="onPasswordChanged()"
    />

    <!-- Right Side Wizard Bar - Dynamic Icon Bar -->
    <aside
      *ngIf="showRightWizard()"
      class="flex flex-col items-center gap-3 py-4 px-2 h-screen z-20 glass-sidebar w-16 border-l"
      [style.border-color]="
        darkMode() ? 'rgba(51, 65, 85, 0.3)' : 'rgba(148, 163, 184, 0.2)'
      "
    >
      <!-- Dynamic Wizard Items -->
      <app-dynamic-wizard
        [wizardItems]="dynamicWizardItems()"
      ></app-dynamic-wizard>

      <!-- User Profile (always visible) -->
      <button
        (click)="toggleUserMenu()"
        class="p-3 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 transition-all hover:scale-110 shadow-md glass-icon"
        title="Profile"
      >
        <div
          class="h-5 w-5 rounded-full bg-white/20 flex items-center justify-center"
        >
          <span class="text-white text-xs font-bold">
            {{ currentUser()?.email?.charAt(0).toUpperCase() || "U" }}
          </span>
        </div>
      </button>

      <!-- Toggle Hide Button -->
      <button
        (click)="toggleRightWizard()"
        class="mt-auto p-3 rounded-full bg-white/80 dark:bg-slate-800/80 hover:bg-white dark:hover:bg-slate-700 transition-all hover:scale-110 shadow-md glass-icon"
        title="Hide"
      >
        <svg
          class="h-5 w-5 text-slate-700 dark:text-slate-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </aside>

    <!-- Toggle Right Wizard Button (when hidden) -->
    <button
      *ngIf="!showRightWizard()"
      (click)="toggleRightWizard()"
      class="fixed right-4 top-1/2 -translate-y-1/2 z-30 p-3 rounded-full glass-icon shadow-lg hover:scale-110 transition-transform"
    >
      <svg
        class="h-5 w-5 text-slate-700 dark:text-slate-300"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>

    <!-- Click outside to close menus -->
    <div
      *ngIf="showNotifications() || showUserMenu() || showSearch()"
      class="fixed inset-0 z-0"
      (click)="closeMenusIfOutside($event)"
    ></div>

    <app-toasts />
    <app-command-palette />
    <!-- Global advanced notifications (top-right toasts & alerts) -->
    <app-advanced-notifications></app-advanced-notifications>

    <!-- Minimized Forms Tray (Gmail-style) -->
    <app-minimized-tray></app-minimized-tray>
  </div>

  <!-- Password Change Modal - Shows before dashboard for first-time users (outside ng-container so it shows on all routes) -->
  <app-password-change-modal
    *ngIf="auth.requiresPasswordChange() && auth.isAuthenticated()"
    (passwordChanged)="onPasswordChanged()"
  />
</ng-container>

<ng-template #authOnly>
  <div
    class="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50/30 to-blue-50/30 dark:from-slate-900 dark:via-purple-900/20 dark:to-blue-900/20 text-slate-900 dark:text-slate-100"
  >
    <router-outlet></router-outlet>
    <app-toasts />
  </div>
</ng-template>
